import Reveal from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { WA } from "../data/site";

const Featured = () => (
    <section id="featured" data-testid="featured-section" className="scroll-mt-24 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <Reveal>
                <div className="max-w-2xl">
                    <p className="eyebrow">Featured</p>
                    <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-red sm:text-5xl">
                        Two paans everyone asks for
                    </h2>
                </div>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2">
                <Reveal className="h-full">
                    <div
                        data-testid="featured-golden-rocher"
                        className="group flex h-full flex-col overflow-hidden rounded-2xl border border-saga-red/15 bg-saga-creamlight shadow-[0_16px_48px_rgba(105,0,3,0.08)]"
                    >
                        <a href="#menu-couverture-saga" className="block overflow-hidden" aria-label="Golden Rocher — view in the menu">
                            <img
                                src="/assets/saga-golden-rocher.jpg"
                                alt="Golden Rocher paan dipped in chocolate with dark drizzle, beside Ferrero Rocher and fresh betel leaves"
                                loading="lazy"
                                className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                        </a>
                        <div className="flex flex-1 flex-col p-8">
                            <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-saga-red/60">The Couverture Saga</p>
                            <h3 className="mt-2 font-display text-3xl font-semibold text-saga-ink">Golden Rocher</h3>
                            <p className="mt-3 text-sm leading-relaxed text-saga-ink/65 sm:text-base">
                                Ferrero Rocher stuffed inside, dipped in hazelnut milk couverture. Hyderabad's most luxurious paan.
                            </p>
                            <div className="mt-auto flex flex-wrap items-center gap-5 pt-6">
                                <a
                                    href={WA.signature}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="featured-rocher-whatsapp"
                                    className="inline-flex items-center gap-2 rounded-full bg-saga-red px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.15em] text-saga-cream transition-colors hover:bg-saga-reddeep"
                                >
                                    <WhatsAppIcon className="h-4 w-4" />
                                    Enquire on WhatsApp
                                </a>
                                <a
                                    href="#menu-couverture-saga"
                                    data-testid="featured-rocher-menu-link"
                                    className="text-[11px] font-bold uppercase tracking-[0.15em] text-saga-red underline-offset-4 hover:underline"
                                >
                                    View in menu
                                </a>
                            </div>
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.1} className="h-full">
                    <div
                        data-testid="featured-night-queen"
                        className="group relative flex h-full flex-col overflow-hidden rounded-2xl bg-saga-red shadow-[0_16px_48px_rgba(105,0,3,0.18)]"
                    >
                        <a href="#menu-signature-saga" className="block px-6 pt-6 sm:px-8 sm:pt-8" aria-label="Night Queen Saga — view in the menu">
                            <img
                                src="/assets/menu-night-queen.jpg"
                                alt="Night Queen Saga — raat-rani floral paan with saffron strands on a golden plate"
                                loading="lazy"
                                className="w-full rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.25)] transition-transform duration-700 group-hover:scale-[1.02]"
                            />
                        </a>
                        <img
                            src="/assets/logo-emblem.png"
                            alt=""
                            aria-hidden="true"
                            className="pointer-events-none absolute -bottom-10 -right-10 h-56 w-56 opacity-15 transition-transform duration-700 group-hover:scale-110"
                        />
                        <div className="flex h-full flex-col p-8 sm:p-10">
                            <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-saga-cream/60">The Signature Saga</p>
                            <h3 className="mt-2 font-display text-3xl font-semibold text-saga-cream">Night Queen Saga</h3>
                            <p className="mt-3 max-w-md text-sm leading-relaxed text-saga-cream/80 sm:text-base">
                                The Midnight Bloom — mysterious raat-rani floral aroma paan. Sweet, aromatic &amp; highly addictive. Our #1 night seller.
                            </p>
                            <div className="mt-auto flex flex-wrap items-center gap-5 pt-10">
                                <a
                                    href={WA.signature}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="featured-night-queen-whatsapp"
                                    className="inline-flex items-center gap-2 rounded-full bg-saga-cream px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.15em] text-saga-red transition-colors hover:bg-saga-creamlight"
                                >
                                    <WhatsAppIcon className="h-4 w-4" />
                                    Enquire on WhatsApp
                                </a>
                                <a
                                    href="#menu-signature-saga"
                                    data-testid="featured-night-queen-menu-link"
                                    className="text-[11px] font-bold uppercase tracking-[0.15em] text-saga-cream/80 underline-offset-4 transition-colors hover:text-saga-cream hover:underline"
                                >
                                    View in menu
                                </a>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Featured;
